/* eslint-disable no-unused-vars */
import { Fragment, useEffect, useRef, useState } from 'react';

import { getFilterKey, successToast, useOutsideClick } from '../../../utils/helper';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { EXPERT_ACCOUNT_STATUS, EXPERT_PROFILE_STATUS } from '../../../utils/constants';
import Pagination from '../../../component/common/Pagination/Pagination';
import { Api } from '../../../api';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { SPECIALIST_ROLE } from '../../../utils/constants';
import moment from 'moment';
import Loader from '../../../component/common/Loader';
import RejectExpertPopup from '../../../component/common/modals/RejectExpertPopup';
import { Link, useNavigate } from 'react-router-dom';
import { CommonTable } from '../../../component/common/table2/CommonTable';
import CommonPopover from '../../../component/common/popover';
import FormSelect from '../../../component/common/FormSelect';
import { pageOptions } from '../../../utils/dropDownConfig';
import { SpecialistPageData } from '../../../utils/pageContent';

function ActiveSpecialist() {
  const wrapperRef = useRef(null);
  const [query, setQuery] = useState('');
  const [jobs, setJobs] = useState(SPECIALIST_ROLE);
  const [loader, setLoader] = useState(true);
  const [usersList, setUsersList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTermDebounce, setSearchTermDebounce] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(pageOptions[0]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterCriteria, setFilterCriteria] = useState({
    accountType: '',
    accountStatus: '',
    loginPlatform: ''
  });
  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [payload, setPayload] = useState(null);

  const navigate = useNavigate();
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const tabData = SpecialistPageData.activeSpecialistTabData;

  /////////////

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentPage(1);
      setSearchTerm(searchTermDebounce);
    }, 700);

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [searchTermDebounce]);

  useOutsideClick(wrapperRef, () => {
    if (showFilterModal) setShowFilterModal(!showFilterModal);
  });

  useEffect(() => {
    const filteredJobs =
      query && query === ''
        ? SPECIALIST_ROLE
        : SPECIALIST_ROLE?.filter((job) => {
            return job.name.toLowerCase().includes(query.toLowerCase());
          });

    setJobs(filteredJobs);
  }, [query]);

  useEffect(() => {
    fetchUsers(currentPage, selectedPerPage.value, '', searchTerm);
  }, [searchTerm, currentPage, selectedPerPage]);

  const fetchUsers = (pageNumber, pageSize, userId, searchKey = '') => {
    setLoader(true);
    const status = EXPERT_PROFILE_STATUS.find((item) => item.tag === 'approved').value;
    Api.getSpecialistData(pageNumber, pageSize, userId, searchKey, status)

      .then((response) => {
        setLoader(false);
        if (response?.data?.meta?.code === 1) {
          setUsersList(response?.data?.data);
          setCurrentPage(pageNumber);
          console.log('🚀 ~ fetchUsers ~ response:', response.data.data);
          setTotalCount(response?.data?.meta?.totalRecords);
        } else {
          setUsersList([]);
          setTotalCount(0);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.error('API call error: ', error);
      });
  };

  const handlePagination = (pageNumber, pageSize, userId) => {
    fetchUsers(pageNumber, pageSize, userId, searchTerm);
  };

  const columns = [
    {
      header: 'Specialist Name',
      cell: ({ row }) => {
        return (
          <Link
            to={`/peap-management/profile/${row?.original?.id}`}
            className="text-sm text-shoorah-active font-medium underline"
          >
            {row?.original?.name}
          </Link>
        );
      },
      meta: {
        rowClassName: 'text-sm',
        className: 'text-sm'
      }
    },
    {
      header: 'Email',
      accessorKey: 'email',
      meta: {
        rowClassName: 'text-sm',
        className: 'text-sm'
      }
    },
    {
      header: 'Sessions',
      accessorKey: 'sessions',
      meta: {
        rowClassName: 'text-center text-sm',
        className: 'text-center text-sm'
      }
    },
    {
      header: 'Date Joined',

      accessorKey: 'dateJoined',
      meta: {
        rowClassName: 'text-sm',
        className: 'text-sm'
      }
    },
    {
      header: 'Clients',
      accessorKey: 'clients',
      meta: {
        rowClassName: 'text-center text-sm',
        className: 'text-center text-sm'
      }
    },
    {
      header: 'Status',
      accessorKey: 'status',
      meta: {
        rowClassName: 'text-sm',
        className: 'text-sm'
      }
    },
    {
      header: 'Complaints',
      accessorKey: 'complaints',
      meta: {
        rowClassName: 'text-center text-sm',
        className: 'text-center text-sm'
      }
    },
    {
      header: 'Rating',
      accessorKey: 'rating',
      meta: {
        rowClassName: 'text-center text-sm',
        className: 'text-center text-sm'
      }
    },
    {
      header: 'Price',
      accessorKey: 'price',
      meta: {
        rowClassName: 'text-center text-sm',
        className: 'text-center text-sm'
      }
    },
    {
      header: 'Identity',
      accessorKey: 'identity',
      meta: {
        rowClassName: 'text-center text-sm',
        className: 'text-center text-sm'
      }
    },
    {
      header: 'DBS',
      accessorKey: 'dbs',
      meta: {
        rowClassName: 'text-center text-sm',
        className: 'text-center text-sm'
      }
    },
    {
      header: 'Unread Massages',
      accessorKey: 'unreadMessages',
      meta: {
        rowClassName: 'text-center text-sm',
        className: 'text-center text-sm'
      }
    },
    {
      header: 'Action',
      cell: ({ row }) => {
        const user = row?.original;
        return (
          <CommonPopover
            label={
              <>
                <span>{tabData.tableHeaderText.actionMenuOptions.select}</span>
                <ChevronDownIcon className="w-5 h-5" />
              </>
            }
            className={`w-[120px] gap-3 text-sm py-2 rounded-[5px] text-black dark:text-white border-shoorah-gray10`}
            contentClassName={`w-[155px] rounded-2xl mt-2 px-0 py-[10px]`}
          >
            <div className={`text-base`}>
              {EXPERT_ACCOUNT_STATUS.PUSHED === user.expert.account_status ? (
                <button
                  onClick={handleActive.bind(null, EXPERT_ACCOUNT_STATUS.ACTIVE, user)}
                  class=" px-6 py-3 outline-none text-sm w-full  text-left hover:text-shoorah-secondary hover:bg-[#E5EAF966]"
                >
                  {tabData.tableHeaderText.actionMenuOptions.active}
                </button>
              ) : (
                <button
                  onClick={handleActions.bind(null, EXPERT_ACCOUNT_STATUS.PUSHED, user)}
                  class="px-6 py-3 outline-none text-sm w-full  text-left hover:text-shoorah-secondary hover:bg-[#E5EAF966]"
                >
                  {tabData.tableHeaderText.actionMenuOptions.pause}
                </button>
              )}

              {EXPERT_ACCOUNT_STATUS.DEACTIVATED === user.expert.account_status ? (
                <button
                  onClick={handleActive.bind(null, EXPERT_ACCOUNT_STATUS.ACTIVE, user)}
                  class="px-6 py-3 outline-none text-sm w-full  text-left hover:text-shoorah-secondary hover:bg-[#E5EAF966]"
                >
                  {tabData.tableHeaderText.actionMenuOptions.reActivate}
                </button>
              ) : (
                <button
                  onClick={handleActions.bind(null, EXPERT_ACCOUNT_STATUS.DEACTIVATED, user)}
                  class="px-6 py-3 outline-none text-sm w-full  text-left hover:text-shoorah-secondary hover:bg-[#E5EAF966]"
                >
                  {tabData.tableHeaderText.actionMenuOptions.deActivate}
                </button>
              )}
            </div>
          </CommonPopover>
        );
      },
      meta: {
        rowClassName: 'text-base',
        className: 'text-base'
      }
    }
  ];

  const handleSubmit = async (reason) => {
    setIsLoading(true);
    try {
      const response = await Api.updatePeapExpertaccountStatus({
        ...payload,
        reject_reason: reason
      });
      if (response.data.meta.code === 200) {
        successToast(`Account ${payload.status === 1 ? 'deactivated' : 'paused'} successfully`);
        fetchUsers(currentPage, selectedPerPage.value, '', searchTerm);
        setOpenRejectModal(false);
      }
    } catch (error) {
      console.log('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleActions = (value, rowData) => {
    const payload = {
      expertId: rowData.expert._id,
      status: value
    };

    // Define the confirmation messages
    const confirmationMessages = {
      2: `Are you sure you want to pause this expert?`,
      1: `Are you sure you want to deactivate this expert?`,
      0: `Are you sure you want to activate this expert?`
    };

    setConfirmationMessage(confirmationMessages[value]);
    setOpenRejectModal(true);
    setPayload(payload);
  };

  const handleActive = async (status, rowData) => {
    const payload = {
      expertId: rowData.expert._id,
      status
    };
    try {
      const response = await Api.updatePeapExpertaccountStatus(payload);
      if (response.data.meta.code === 200) {
        fetchUsers(currentPage, selectedPerPage.value, '', searchTerm);
        successToast('Acount activated successfully.');
        // setOpenRejectModal(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  console.log('🚀 ~ tableData ~ usersList:', usersList);

  const tableData = usersList.map((user) => {
    return {
      ...user,
      sessions: user.numberOfSessions?.toString(),
      dateJoined: moment(user.createdAt).format('DD MMM, yyyy') || 'N/A',
      status:
        user.expert.account_status === EXPERT_ACCOUNT_STATUS.ACTIVE
          ? 'Active'
          : user.expert.account_status === EXPERT_ACCOUNT_STATUS.PUSHED
          ? 'Paused'
          : 'Deactivated',
      clients: user.numberOfClients?.toString(),
      rating: user.rating?.toString(),
      price: `£${user.expert.price_per_hour}` || 'N/A',
      identity: user.expert.workflow_success === 1 ? 'Approved' : 'Rejected',
      complaints: user.numberOfComplaints?.toString(),
      dbs: user.expert.DBSapproved ? 'Verified' : 'Unverified',
      unreadMessages: user.numberOfUnreadMessages?.toString(),
      expertId: user.expert._id
    };
  });

  return (
    <>
      <RejectExpertPopup
        open={openRejectModal}
        onClose={() => setOpenRejectModal(false)}
        onSubmit={handleSubmit}
        message={confirmationMessage}
        isLoadingUpdate={isLoading}
      />
      <div>
        {loader && <Loader />}

        <div>
          

          <div className="mt-5 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder rounded-[16px] border-[1.5px] border-shoorah-borderGray p-3 md:p-6">
            <div>
              <h2 className="text-xl font-medium leading-9">{tabData.tabTitle}</h2>
              <p className="text-base">{tabData.tabDescription}</p>
            </div>
            <div className="mt-5">
              <FormSelect
                options={pageOptions}
                name={'recordsPerPage'}
                value={selectedPerPage.value}
                className="bg-transparent  w-[200px] text-[14px] leading-6"
                onChange={(_, value) => {
                  const opt = pageOptions.find((x) => x.value === value);
                  setSelectedPerPage(opt);
                }}
              />
            </div>
            <div className="pt-3">
              <CommonTable columns={columns} data={tableData} />
            </div>
          </div>
        </div>
        <div>
          {totalCount > selectedPerPage?.value ? (
            <Pagination
              currentPage={currentPage}
              totalCount={totalCount}
              pageSize={selectedPerPage?.value}
              onPageChange={(page) => setCurrentPage(page)}
            />
          ) : (
            <span />
          )}
        </div>
      </div>
    </>
  );
}

export default ActiveSpecialist;
